export const configs = {
  cmoverse_url: process.env.REACT_APP_CMO_VERSE_URL,
  cmoweb_url: process.env.REACT_APP_CMO_WEB_URL,
  auth_url: process.env.REACT_APP_API_AUTH_URL, 
  api_key: process.env.REACT_APP_CMO_API_KEY,
  rag_base_url: process.env.REACT_APP_RAG_BASE_URL || "http://localhost:8505",
};



